import { InputNumber } from 'primereact/inputnumber'
import React, { useEffect, useState } from 'react'
import SaveButton from '../../buttons/SaveButton'
import './matrixInputs.scss'

const MatrixInput = ({ initialValues, name, onChange }) => {
  const [matrix, setMatrix] = useState([])

  useEffect(() => {
    if (initialValues && initialValues.length > 0) {
      setMatrix(initialValues)
    } else {
      setMatrix([[0, 0]])
    }
  }, [initialValues])

  const addRow = () => {
    setMatrix([...matrix, [0, 0]])
  }

  const handleValueChange = (value, rowIndex, columnIndex) => {
    const updatedMatrix = [...matrix]
    updatedMatrix[rowIndex][columnIndex] = value
    setMatrix(updatedMatrix)
    onChange({ target: { value: updatedMatrix, name } })
  }

  return (
    <div className="matrix-container">
      <div className="matrix-wrapper">
        {matrix.map((row, rowIndex) => (
          <div key={rowIndex} className="matrix-content">
            <div className="flex-container ">
              <div className="control-input">
                <InputNumber
                  value={row[0]}
                  onChange={(e) => handleValueChange(e.value, rowIndex, 0)}
                />
              </div>
            </div>
            <span> - </span>
            <div className="flex-container ">
              <div className="control-input">
                <InputNumber
                  value={row[1]}
                  onChange={(e) => handleValueChange(e.value, rowIndex, 1)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <SaveButton
        btnText="button.add.transport.tanks"
        btnClass="btn__bg-dark-blue"
        onClick={addRow}
      />
    </div>
  )
}

export default MatrixInput
